import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  Container,
  InputGroup,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import { logout } from "../../utils";
import { notification } from "antd";

import { Routes } from "../../routes";
import axios from "../../axios";
import { GetData as t } from "../../lingual";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      success: false,
      message: "",
    };
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  openNotificationWithIcon = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
    });
  };

  handleEmailChange(event) {
    this.setState({ email: event.target.value });
  }
  handleSubmit = (event) => {
    console.log(event);
    let data = {
      username: this.state.email,
    };

    axios
      .post(`auth/recoverpassword`, data)
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          if (res.data.error) {
            this.openNotificationWithIcon(
              "warning",
              t("login_screen"),
              res.data.error.message
            );
          } else {
            this.setState({
              success: true,
              message: t("recover_success_message"),
            });
          }
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          this.openNotificationWithIcon(
            "warning",
            t("invalid_login"),
            t("please_try_again")
          );

          logout();
          this.props.history.push("/login");
        } else {
          this.openNotificationWithIcon(
            "warning",
            t("something_went_wrong"),
            t("please_contact_adminstrator")
          );
        }
      });

    event.preventDefault();
  };

  render() {
    return (
      <main>
        <section className="vh-lg-100 mt-4 mt-lg-0 bg-soft d-flex align-items-center">
          <Container>
            <Row className="justify-content-center">
              <p className="text-center">
                <Card.Link
                  as={Link}
                  to={Routes.Signin.path}
                  className="text-gray-700"
                >
                  <FontAwesomeIcon icon={faAngleLeft} className="me-2" />
                  {t("back_sign_in")}
                </Card.Link>
              </p>
              <Col
                xs={12}
                className="d-flex align-items-center justify-content-center"
              >
                <div className="signin-inner my-3 my-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                  {this.state.success ? (
                    <h3 className="text-center">{this.state.message}</h3>
                  ) : (
                    <div>
                      <h3>{t("recover_password_title")}</h3>
                      <p className="mb-4">{t("recover_password_message")}</p>
                      <Form onSubmit={this.handleSubmit}>
                        <div className="mb-4">
                          <Form.Label htmlFor="email">
                            {t("your_email")}
                          </Form.Label>
                          <InputGroup id="email">
                            <Form.Control
                              required
                              autoFocus
                              type="email"
                              placeholder={t("email_placeholder")}
                              onChange={this.handleEmailChange}
                              value={this.state.email}
                            />
                          </InputGroup>
                        </div>
                        <Button
                          variant="primary"
                          type="submit"
                          className="w-100"
                        >
                          {t("recover_password")}
                        </Button>
                      </Form>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
    );
  }
}

export default ForgotPassword;
